import React from 'react';
import { Helmet } from 'react-helmet';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
    locale?: string;
    author?: string;
    keywords?: string[];
    imageWidth?: number;
    imageHeight?: number;
}

const SEO: React.FC<SEOProps> = ({
                                     title = "MrBlackCat - Full Stack Developer & IoT Specialist",
                                     description = "Expert Full Stack Developer specializing in Python, PHP, C/C++, and IoT solutions. Creating innovative ESP32 projects and multilingual applications. Available for consulting and collaboration.",
                                     image = "./assets/images/og-image.jpg",
                                     url = "./",
                                     type = "website",
                                     locale = "en_US",
                                     author = "MrBlackCat",
                                     keywords = ["Full Stack Developer", "IoT Developer", "Python", "PHP", "C++", "ESP32", "Multilingual Developer"],
                                     imageWidth = 1200,
                                     imageHeight = 630
                                 }) => {
    const baseUrl = process.env.REACT_APP_BASE_URL || '';
    const fullImageUrl = `${baseUrl}${image}`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <html lang="en" />
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <meta name="author" content={author} />
            <meta name="keywords" content={keywords.join(', ')} />
            <link rel="canonical" href={`${baseUrl}${url}`} />

            {/* OpenGraph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={`${baseUrl}${url}`} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:image:width" content={imageWidth.toString()} />
            <meta property="og:image:height" content={imageHeight.toString()} />
            <meta property="og:locale" content={locale} />
            <meta property="og:site_name" content={title} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={`${baseUrl}${url}`} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={fullImageUrl} />
            <meta name="twitter:creator" content={`@${author}`} />

            {/* Additional Meta Tags */}
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta name="theme-color" content="#000000" />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Person",
                    "name": author,
                    "url": `${baseUrl}${url}`,
                    "sameAs": [
                        "https://github.com/mrblackcatdev",
                        "https://t.me/mrblackcatdev",
                        "https://steamcommunity.com/id/mrblackcatdev",
                        "https://www.instagram.com/m1blackcat"
                    ],
                    "jobTitle": "Full Stack Developer",
                    "knowsLanguage": ["English", "German", "Russian", "Ukrainian"],
                    "knowsAbout": ["Python", "PHP", "C++", "IoT", "ESP32"],
                    "image": fullImageUrl,
                    "description": description
                })}
            </script>
        </Helmet>
    );
};

export default SEO;